// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-settings-control-forum-feed .EditWidgetContentPadding .fi-select-search .mat-mdc-form-field {
  width: 100%;
}

.fi-select-search-panel .cdk-virtual-scroll-content-wrapper {
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/widget-settings/controls/forum-feed/forum-feed.component.scss"],"names":[],"mappings":"AAGY;EACI,WAAA;AAFhB;;AASI;EACI,eAAA;AANR","sourcesContent":[".widget-settings-control-forum-feed {\r\n    .EditWidgetContentPadding {\r\n        .fi-select-search {\r\n            .mat-mdc-form-field {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.fi-select-search-panel {\r\n    .cdk-virtual-scroll-content-wrapper {\r\n        max-width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
